import { type ElementType, type ReactNode } from "react";
import { cn } from "@/utils/helpers/classnames";

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

interface HeadingProps extends React.HTMLAttributes<HTMLElement> {
  as?: ElementType;
  level?: HeadingLevel;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const headingVariants: Record<HeadingLevel, string> = {
  1: "text-3xl md:text-4xl lg:text-5xl font-semibold ",
  2: "text-2xl md:text-3xl lg:text-4xl font-semibold ",
  3: "text-xl md:text-2xl lg:text-3xl font-medium ",
  4: "text-lg md:text-xl lg:text-2xl font-medium",
  5: "text-base md:text-lg lg:text-xl font-medium",
  6: "text-sm md:text-base lg:text-lg font-medium",
};

const Heading = ({
  as,
  level = 1,
  children,
  className,
  style,
}: HeadingProps) => {
  const Component = as ?? (`h${level}` as ElementType);

  return (
    <Component
      className={cn(
        "font-pt-serif text-[#181717]", 
        headingVariants[level],
        className
      )}
      style={style}
    >
      {children}
    </Component>
  );
}

export default Heading;